import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import Lock from '@mui/icons-material/Lock'
import { Box, Button, Stack } from '@mui/material'
import { ReactNode } from 'react'
import { InfoNeededCorner } from '../../../../../components/TraitTable/InfoNeededCorner'
import { useProgramEngagementContext } from '../../../../../context'

import { FieldModel } from '@cibo/core'

interface TraitCellContainerProps {
  value: any
  children: ReactNode
  task: any
  year: number
  selectedField: FieldModel | null
  traitId: string
  onAdd?: () => void
}

export const TraitCellContainer = ({
  value,
  children,
  onAdd,
  task,
  selectedField,
  year,
  traitId,
}: TraitCellContainerProps) => {
  const { engagement, program } = useProgramEngagementContext()

  const ruleParams = task.rule?.params || {}

  const benchmarkName = ruleParams.benchmarkName
  const benchmarkRequirements = program.data?.benchmarks?.find(
    benchmark => benchmark.benchmark === benchmarkName
  )?.details

  const relevantRequirement =
    benchmarkRequirements &&
    benchmarkRequirements.find((req: any) => req.traitId === traitId && req.year === year)

  const infoNeededV2 =
    selectedField?.id && task && relevantRequirement
      ? engagement.data?.taskIsMissingFieldInfo(
          task.id, // task.id
          selectedField?.resourceId,
          relevantRequirement
        )
      : true

  if (!value) {
    return (
      <Button
        sx={{
          height: 64,
          p: 1,
          m: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '100%',
        }}
        onClick={onAdd ?? (() => console.log('Add clicked'))}
      >
        {infoNeededV2 && <InfoNeededCorner style={{ marginTop: '-8px', marginLeft: '-8px' }} />}
        <AddIcon color="action" />
      </Button>
    )
  }

  if (value.immutable) {
    return (
      <Box
        sx={{
          height: 64,
          backgroundColor: '#18303814',
          borderRadius: '4px',
          m: 1,
          p: 1,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          width: '100%',
        }}
      >
        <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
          {children}

          <Lock fontSize="small" color="disabled" sx={{ opacity: '0.5' }} />
        </Stack>
      </Box>
    )
  }
  return (
    <Button
      sx={{
        height: 64,
        // backgroundColor: '#18303814',
        borderRadius: '4px',
        m: 1,
        p: 1,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
        textAlign: 'left',
        color: 'text.primary',
        position: 'relative',
        '&:hover .edit-icon': {
          opacity: 1,
        },
      }}
      onClick={onAdd ?? (() => console.log('Add clicked'))}
    >
      {infoNeededV2 && <InfoNeededCorner style={{ marginTop: '-8px', marginLeft: '-8px' }} />}
      <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
        {children}

        <EditIcon
          className="edit-icon"
          color="action"
          fontSize="small"
          sx={{ opacity: 0, transition: 'opacity 0.2s' }}
        />
      </Stack>
    </Button>
  )
}
